<template>
  <div class="login_popup">
    <el-dialog :visible.sync="dialogTableVisible" center custom-class="dialog_box">
      <template #title>
        <div class="dialog_title">申请加入我们</div>
      </template>
      <div class="text">请完善以下信息，我们将在2个工作日内与您联系</div>
      <div style="width: 409px; margin: 0 auto;margin-top: 32px;">
        <el-form ref="formRef" :model="formData" :rules="rules" label-width="0px" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input class="dialog_input" v-model="formData.name" placeholder="请输入您的姓名">

            </el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input class="dialog_input" v-model="formData.phone" type="text" placeholder="请输入您的联系电话">

            </el-input>
          </el-form-item>
          <el-form-item prop="fullName">
            <el-input class="dialog_input" v-model="formData.fullName" type="text" placeholder="请输入您的企业名称">

            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex;width: 409px;margin: 0 auto;align-items: center;">
        <img style="width: 21px;" v-show="!isAgreement" @click="isAgreement = true"
          src="../../assets/login/checkoutNone_icon.png" alt="">
        <img style="width: 21px;" v-show="isAgreement" @click="isAgreement = false"
          src="../../assets/login/checkout_icon.png" alt="">
        <div class="dialog_agreement">打勾表示您已阅读并同意 <a @click="goTo" style="color: rgb(56, 96, 226);">《上啥班云管家用户服务协议》</a>
          以及<a @click="goTo1" style="color: rgb(56, 96, 226);"> 《上啥班云平台用户隐私协议》</a></div>
      </div>
      <el-button class="register_btn" @click="contactUs">提交</el-button>
      <div v-show="isTost" class="tost_box">{{ tostMsg }}</div>

    </el-dialog>
  </div>
</template>

<script>
import { contactUs } from "@/api/common";

export default {
  components: {},
  props: {},
  data() {
    const validatePhone = (rule, value, callback) => {
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      console.log(value);

      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (value.length != 11 || !reg.test(this.formData.phone)) {
        callback(new Error('请输入正确的手机号'))
      } else {

        callback()
      }
    }
    const validatefullName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业名称'))
      } else if (value !== this.formData.name) {
        // callback(new Error("Two inputs don't match!"))
      } else {
        callback()
      }
    }
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入姓名'))
      } else if (value !== this.formData.name) {
        // callback(new Error("Two inputs don't match!"))
      } else {
        callback()
      }
    }
    return {
      isTost: false,
      tostMsg: '',
      formData: {
        name: '',
        phone: '',
        fullName: '',


      },
      dialogTableVisible: false,
      isAgreement: false,
      rules: {
        name: [{ validator: validateName, trigger: ['blur'] }],
        phone: [{ validator: validatePhone, trigger: ['blur'] }],
        fullName: [{ validator: validatefullName, trigger: ['blur'] }],
      }
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() { },
  methods: {
    goTo() {
      this.$router.push({ path: "/agreementsUser" });
    },
    goTo1() {
      this.$router.push({ path: "/privacyPolicy" });
    },
    showTost(msg) {
      this.tostMsg = msg;
      this.isTost = true;
      let timer = setTimeout(() => {
        this.tostMsg = '';
        this.isTost = false;
        clearTimeout(timer);
      }, 2000)
    },
    async contactUs() {
      let obj = {
        phone: this.formData.phone,
        name: this.formData.name,
        fullName: this.formData.fullName
      }
      if (!obj.name) {
        this.showTost('请完善您的姓名')
        return
      }
      if (!obj.phone) {
        this.showTost('请完善您的联系电话')
        return
      }
      if (!obj.fullName) {
        this.showTost('请完善您的公司全称')
        return
      }
      if (!this.isAgreement) {
        this.showTost('请确认并同意隐私政策后提交')
        return
      }
      let res = await contactUs(obj)
      this.showTost(res.msg)
      if (res.no == 1) {
        this.hide();
      }
      console.log(res);
    },
    show() {
      this.dialogTableVisible = true
    },
    hide() {
      this.dialogTableVisible = false
    }
  },
};
</script>
<style lang="scss" scoped>
.tost_box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 222px;
  height: 38px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 38px;
  text-align: center;
  background-color: #333333;
  border-radius: 3px;
}

.wrapper {}
</style>
<style  lang='scss'>
.login_popup {
  .el-input__inner {
    width: 409px;
    height: 47px !important;
    background: #FFFFFF;
    border-radius: 7px 7px 7px 7px;
    border: 1px solid #DCDCDC;
    margin-top: 3px;
  }

  .el-input__prefix {
    display: flex;
    align-items: center;
  }

  .dialog_box {
    width: 515px !important;
    height: 499px;
    background: #FFFFFF;
    border-radius: 17px 17px 17px 17px;
  }

  .el-dialog__body {
    padding: 0;
  }

  .dialog_title {
    font-size: 24px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    text-align: center;
    margin: 0 auto;
  }

  .text {
    height: 32px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
    margin: 0 auto;
    text-align: center;
  }

  .dialog_input {
    width: 409px;
    height: 47px;
    background: #FFFFFF;
    border-radius: 7px 7px 7px 7px;
    margin-bottom: 3px;
  }

  .dialog_agreement {
    width: 360px;
    height: 37px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 19px;
    margin-left: 12px;
    text-align: left;
  }

  .register_btn {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 409px;
    height: 47px;
    background: #3860E2;
    color: #FFFFFF;
    border-radius: 7px 7px 7px 7px;
    margin-top: 37px;
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    // margin: 0 auto;
  }

  .register_btn:hover,
  .register_btn:focus {
    background: #3860E2 !important;
    color: #FFFFFF;
    border-radius: 7px 7px 7px 7px;
    margin-top: 37px;
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    // margin: 0 auto;
  }
}

.el-dialog__header {
  padding-top: 35px;
}
</style>


// WEBPACK FOOTER //
// src/components/loginComponents/joinPopup.vue